module.exports = require("react-player");